<template>
    <div class="page-sharer">
        <dropdown v-bind="$attrs"
                :facets="['sharer']"
                :items="socials"
                :open-icon="openIcon"
                :closed-icon="closedIcon"/>
    </div>
</template>

<script>
    import { getWhatsappLinkFromParamsObject } from 'util/dom/whatsapp-link';
    import Dropdown from 'framework/global-components/dropdown/dropdown';

    const { location } = window;
    // generated via http://www.sharelinkgenerator.com/
    const socials = [{
        icon: { symbol: 'facebook', size: 'medium' },
        label: 'Facebook',
        facets: ['facebook'],
        external: true,
        path: `https://www.facebook.com/sharer/sharer.php?u=${ location }`,
    }, {
        icon: { symbol: 'twitter', size: 'medium' },
        label: 'Twitter',
        facets: ['twitter'],
        external: true,
        path: `https://twitter.com/home?status=${ location }`,
    }, {
        icon: { symbol: 'linkedin', size: 'medium' },
        label: 'Linkedin',
        facets: ['linkedin'],
        external: true,
        path: `https://www.linkedin.com/shareArticle?mini=true&url=${ location }`,
    }, {
        icon: { symbol: 'whatsapp', size: 'medium' },
        label: 'Whatsapp',
        facets: ['whatstapp'],
        external: true,
        path: getWhatsappLinkFromParamsObject({ text: location }),
    }, {
        icon: { symbol: 'mail', size: 'medium' },
        label: 'E-Mail',
        facets: ['mail'],
        external: true,
        path: `mailto:?body=${ location }`,
    }];

    export default {
        components: { Dropdown },
        data() {
            return { socials };
        },
        computed: {
            closedIcon() {
                return {
                    symbol: 'share',
                    size: 'medium',
                };
            },
            openIcon() {
                return {
                    symbol: 'triangle-up',
                    size: 'small',
                };
            },
        },
    };
</script>
